module.exports = __webpack_public_path__ + "img/domain14-icon-6.4490e410.webp";